import "./src/styles/global.css"
import React from "react"
import { SiteProvider } from "./src/context/SiteContext"

export const wrapRootElement = ({ element }) => (
  <SiteProvider>{element}</SiteProvider>
)
